import React from 'react';

import { Text } from '@reckon-web/text';

interface IActivityPropertyFloat {
  value?: string | null;
}

// ActivityProperty Float = 3
export const ActivityPropertyFloat = ({ value }: IActivityPropertyFloat) => {
  const formattedValue = () => {
    if (value === null || value === undefined || value === '') {
      return '';
    }
    const parsedVal = parseFloat(value);
    if (isNaN(parsedVal)) {
      // we tried, doesn't parse, just return the string
      return value;
    }

    // give it a splash of nice with some commas
    // but make sure we don't accidentally truncate the decimal place digits. If the value is 3.1415927, need to display that
    // and not the default of 3 decimal places
    return parsedVal.toLocaleString(undefined, {
      maximumSignificantDigits: 20,
    });
  };
  return (
    <Text size="small" weight="semibold">
      {formattedValue()}
    </Text>
  );
};
